export const DEFAULT_TIMEZONE_OFFSET = '+00:00';

// Timezone that is designed to return always UTC+00:00
export const STANDARD_TIMEZONE_ID = 'Etc/GMT';
